import { render, staticRenderFns } from "./AcceptorLogs.vue?vue&type=template&id=47003208"
import script from "./AcceptorLogs.vue?vue&type=script&lang=js"
export * from "./AcceptorLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports